/*
 * @Desc: 页面路由(使用小驼峰规则命名，如videoDetail、goodsList)
 * @Author: 赵佳明
 * @Date: 2023-01-30 09:11:04
 * @LastEditors: 赵佳明
 * @LastEditTime: 2023-02-03 10:15:36
 * Copyright (c) 2023 山木枝(河北)技术服务有限公司, All Rights Reserved.
 */

/**
 * meta中 role       为角色权限，决定用户是否有权限访问该路由
 * keepAlive        为缓存选项，如果该路由需要缓存，值设为true
 * requiresAuth     验证登录权限
 * title            页面标题
 */

import nofound from '.././components/Nofound.vue';
import iframe from '.././components/Iframe.vue';

// user    role:0
import Home from '@/views/Home';
import About from '@/views/About';
import Business from '@/views/Business';
import Case from '@/views/Case';
import CaseInfo from '@/views/CaseInfo';
import Contact from '@/views/Contact';
import Team from '@/views/Team';

export default [
  // 内容的模板
  {
    path: '/',
    component: iframe,
    meta: {
      requiresAuth: false,
    },
    children: [
      // 首页
      {
        path: '/',
        name: 'home',
        component: Home,
        meta: {
          requiresAuth: false,
          title: '首页',
          role: 0,
          keepAlive: false,
        },
      },
      // 业务
      {
        path: 'business',
        name: 'business',
        component: Business,
        meta: {
          requiresAuth: false,
          title: '业务',
          role: 0,
          keepAlive: false,
        },
      },
      // 案例
      {
        path: 'case',
        name: 'case',
        component: Case,
        meta: {
          requiresAuth: false,
          title: '案例',
          role: 0,
          keepAlive: false,
        },
      },
      {
        path: 'caseInfo',
        name: 'caseInfo',
        component: CaseInfo,
        meta: {
          requiresAuth: false,
          title: '案例内容',
          role: 0,
          keepAlive: false,
        },
      },
      // 关于
      {
        path: 'about',
        name: 'about',
        component: About,
        meta: {
          requiresAuth: false,
          title: '关于',
          role: 0,
          keepAlive: false,
        },
      },
      // 团队
      {
        path: '/team',
        name: 'team',
        component: Team,
        meta: {
          requiresAuth: false,
          title: '团队',
          role: 0,
          keepAlive: false,
        },
      },
      // 联系
      {
        path: 'contact',
        name: 'contact',
        component: Contact,
        meta: {
          requiresAuth: false,
          title: '联系',
          role: 0,
          keepAlive: false,
        },
      },
    ],
  },
  {
    path: '/',
    component: () => import('@/components/MobileIframe/index.vue'),
    meta: {
      requiresAuth: false,
    },
    children: [
      // 首页
      {
        path: '',
        redirect: 'phoneIndex',
      },
      {
        path: 'phoneIndex',
        name: 'phone-home',
        component: () => import('@/views/Mobile/Home/index.vue'),
        meta: {
          requiresAuth: false,
          title: '首页',
          role: 0,
          keepAlive: false,
        },
      },
      // 业务
      {
        path: 'phoneBusiness',
        name: 'phone-business',
        component: () => import('@/views/Mobile/Business/index.vue'),
        meta: {
          requiresAuth: false,
          title: '业务',
          role: 0,
          keepAlive: false,
        },
      },
      // 案例
      {
        path: 'phoneCase',
        name: 'phone-case',
        component: () => import('@/views/Mobile/Case/index.vue'),
        meta: {
          requiresAuth: false,
          title: '案例',
          role: 0,
          keepAlive: false,
        },
      },
      // 案例列表
      {
        path: 'phoneCaseList',
        name: 'phone-caseList',
        component: () => import('@/views/Mobile/CaseList/index.vue'),
        meta: {
          requiresAuth: false,
          title: '案例列表',
          role: 0,
          keepAlive: false,
        },
      },
      {
        path: 'phoneCaseInfo',
        name: 'phone-caseInfo',
        component: () => import('@/views/Mobile/CaseInfo/index.vue'),
        meta: {
          requiresAuth: false,
          title: '案例内容',
          role: 0,
          keepAlive: false,
        },
      },
      // 关于
      {
        path: 'phoneAbout',
        name: 'phone-about',
        component: () => import('@/views/Mobile/About/index.vue'),
        meta: {
          requiresAuth: false,
          title: '关于',
          role: 0,
          keepAlive: false,
        },
      },
      // 团队
      {
        path: 'phoneTeam',
        name: 'phone-team',
        component: () => import('@/views/Mobile/Team/index.vue'),
        meta: {
          requiresAuth: false,
          title: '团队',
          role: 0,
          keepAlive: false,
        },
      },
      // 联系
      {
        path: 'phoneContact',
        name: 'phone-contact',
        component: () => import('@/views/Mobile/Contact/index.vue'),
        meta: {
          requiresAuth: false,
          title: '联系',
          role: 0,
          keepAlive: false,
        },
      },
    ],
  },
];
